<template>
    <div class="max-width-content">
        <trashed-message v-if="sitepage.deleted_at" class="mb-6">
            Deze sitepagina is verwijderd
        </trashed-message>

        <div class="flex items-center justify-between">
            <breadcrumbs>
                <inertia-link :href="route('admin.sitepages.index')">Sitepaginas</inertia-link>
                <i class="fad fa-chevron-right"></i>
                {{ sitepage.title | truncate(35) }}
            </breadcrumbs>

            <div v-if="!sitepage.deleted_at">
                <link-button :href="route('admin.sitepages.edit', sitepage.id)" icon="pencil" class="bg-white">Wijzig</link-button>
                <confirm-button method="delete" :href="route('admin.sitepages.destroy', sitepage.id)" icon="trash" class="bg-white hover:bg-red-600 hover:text-white">Verwijder</confirm-button>
            </div>
        </div>

        <h1 class="text-5xl text-teal-800 mr-1 leading-tight mt-3">{{ sitepage.title }}</h1>

        <div class="bg-white px-3 py-2 rounded">
            Url: <a :href="sitepage.url" target="_blank" class="text-green-800 underline">{{ sitepage.url }}</a>
        </div>

        <div class="styled-content mt-3">
            <div v-if="sitepage.body" v-html="sitepage.body"></div>
        </div>
    </div>
</template>

<script>
import Layout from "@/admin/Shared/Layout";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";
import TrashedMessage from "@/admin/Shared/TrashedMessage";
import LinkButton from "@/admin/Shared/LinkButton";
import ConfirmButton from "@/admin/Shared/ConfirmButton";
import TagSelect from "@/admin/Components/TagSelect";

export default {
    layout: Layout,

    mixins: [Helpers],

    components: { Breadcrumbs, TrashedMessage, LinkButton, ConfirmButton, TagSelect },

    props: {
        sitepage: {
            Type: Object
        },
        tags: Array
    },
    data() {
        return {};
    },
    methods: {

        addTag(tag) {
            this.loading = "addTag";

            const url = this.route("admin.sitepages.tags.store", this.sitepage.id);
            const data = {tagId: tag.id};
            const options = {
                preserveState: true,
                preserveScroll: true,
                onFinish: () => {
                    this.tag = ""
                    this.loading = ""
                }
            }
            this.$inertia.post(url, data, options)
        },

        removeTag(tag) {
            this.loading = "removeTag"+tag.id;

            const url = this.route("admin.sitepages.tags.destroy", this.sitepage.id) + "?tagId=" + tag.id;
            const options = {
                preserveState: true,
                preserveScroll: true,
                onFinish: () => {
                    this.tag = ""
                    this.loading = ""
                }
            }

            this.$inertia.delete(url, options)
        },

    },

    computed: {
        url: () => {
            return 'https:://humboldt.earth/'
        }
    },

    metaInfo() {
        return { title: this.sitepage.title + " | Voorvertoning" };
    }
};
</script>
